import { testimonialList } from "@/mocks/naruto";

const principles = [
  { icon: "ri-archive-2-line", title: "认真分类", desc: "每个作品按CP与剧情标签精细整理，方便读者快速定位。" },
  { icon: "ri-verified-badge-line", title: "宁缺毋滥", desc: "推荐坚持剧情与画风并重，只收录经过筛选的优质作品。" },
  { icon: "ri-hand-heart-line", title: "尊重创作", desc: "始终标注作者信息，鼓励读者支持正版与创作者。" },
];

export default function AboutSection() {
  return (
    <section id="about" className="mx-auto w-full max-w-7xl px-4 py-14 md:py-20">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:items-center">
        <div>
          <p className="text-sm font-medium text-primary-600">关于我们</p>
          <h2 className="mt-2 font-display text-3xl leading-snug text-foreground-950 md:text-4xl">
            为爱发电，做一份好用的火影同人本子分类索引
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
            火影同人本子是一个专注于火影同人作品分类与推荐的网站。我们以「按CP找本子」为出发点，
            把鸣人CP、佐助CP、鼬樱、卡卡西、鹿丸、我爱罗等热门角色向作品按剧情与感情基调整理成册，
            让每位读者都能顺着清晰的线索，快速找到想看的那个故事。
          </p>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
            我们相信好故事值得被好好安放。分类、标签、作者信息与剧情介绍，都是为了让你在众多作品之间
            少绕一些路，把时间留给真正打动你的那一页。
          </p>

          <div className="mt-7 grid grid-cols-1 gap-4 sm:grid-cols-3">
            {principles.map((p) => (
              <div key={p.title} className="rounded-lg bg-secondary-100/80 p-4">
                <div className="flex h-10 w-10 items-center justify-center rounded-full bg-secondary-500 text-background-50">
                  <i className={`${p.icon} text-lg`}></i>
                </div>
                <h3 className="mt-3 text-sm font-semibold text-foreground-950">{p.title}</h3>
                <p className="mt-1.5 text-xs leading-relaxed text-foreground-600">{p.desc}</p>
              </div>
            ))}
          </div>
        </div>

        <div>
          <div className="rounded-lg bg-accent-500 p-6 text-background-50 md:p-8">
            <p className="font-display text-2xl">读者口碑</p>
            <p className="mt-2 text-sm text-background-50/90">
              分类好用、推荐靠谱，是同好们对我们的共同评价。
            </p>
          </div>
          <div className="mt-5 flex flex-col gap-4">
            {testimonialList.map((t) => (
              <figure key={t.name} className="rounded-lg bg-background-100 p-5">
                <div className="flex items-center gap-1 text-accent-500">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <i key={i} className="ri-star-fill text-sm"></i>
                  ))}
                </div>
                <blockquote className="mt-3 text-sm leading-relaxed text-foreground-700">{t.text}</blockquote>
                <figcaption className="mt-3 flex items-center gap-2.5">
                  <span className="flex h-9 w-9 items-center justify-center rounded-full bg-secondary-500 text-sm font-medium text-background-50">
                    {t.name.slice(0, 1)}
                  </span>
                  <div>
                    <p className="text-sm font-medium text-foreground-950">{t.name}</p>
                    <p className="text-xs text-foreground-500">{t.role}</p>
                  </div>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}